import React from 'react';

import cx from 'classnames';

import LandingActions from 'components/Pages/Admin/shared/ItinerariesItemLanding/LandingActions';
import { MobileActionsMenu } from 'components/shared/MobileActionsMenu';
import { MOB_APP_BUTTON_MOUNT_POINT } from 'components/shared/MobileAppInfo/constants';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { isMobileBrowser } from 'utils/browserDetect';

import { useGuestPortalData } from '../functions';
import s from './index.module.css';

export const RightActions = () => {
  const { iconsConfig, notifications, actions } = useGuestPortalData();
  const { isTabletOrMobile } = useMediaBreakpoints();
  const isMobilePlatform = isMobileBrowser();

  if (isTabletOrMobile)
    return (
      <div className={cx(s.rightActions, 'custom-right-header-actions-wrapper')}>
        {isMobilePlatform && <div id={MOB_APP_BUTTON_MOUNT_POINT} />}
        <MobileActionsMenu actions={actions} icons={iconsConfig} notifications={notifications} />
      </div>
    );

  return <LandingActions icons={iconsConfig} notifications={notifications} />;
};
